import React from 'react';

import { Icon } from '@iq/react-components';

const Pill = ({ icon, text, onClick, ...properties }) => (
  <div
    data-testid="pill-icon"
    className={`pill-component ${typeof onClick === 'function' ? 'clickable' : ''}`}
    onClick={onClick}
    {...properties}
  >
    {icon ? (
      <Icon
        icon={icon}
        size="s"
      />
    ) : null}
    <div className="text">{text}</div>
  </div>
);

export default Pill;
